import { useView } from '@10000/react'
import { Body, Box, CenteredBox, Locked } from '../widgets'
import { SubscribeButton } from './SubscribeButton'

export const PaidContent = () => {
  const { options } = useView('squiz')

  return options?.free && (
    <Box
      position="absolute"
      inset
      zIndex={1000}
      style={{ backdropFilter: 'blur(5px)' }}
    />
  )
}

export const PaidContentDialog = props => {
  const { options } = useView('squiz')

  return options?.free && (
    <CenteredBox
      column
      position="absolute"
      inset
      zIndex={1001}
      {...props}
    >
      <Box
        column
        fullWidth
        p={24}
        gap={16}
        maxWidth={480}
      >
        <Box
          column
          alignItems="center"
          p={24}
          gap={8}
          r={16}
          border="1px solid #FFF"
          background="black"
          shadow="2px 2px 0 0 #FFF"
        >
          <Locked />
          <Body weight={600} align="center">
            Demo Mode
          </Body>
          <Body align="center">
            To track your progress and securely store your data, you’ll need to choose a subscription.
          </Body>
        </Box>

        <SubscribeButton p={0} />
      </Box>
    </CenteredBox>
  )
}